// src/components/Layout/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

/**
 * ProtectedRoute
 * - Blocks unauthenticated access to protected routes.
 * - Waits for auth bootstrap (authReady) before rendering.
 * - Redirects unauthenticated users to /login.
 * - Works with both token-based and cookie-based sessions.
 */
export default function ProtectedRoute({ children }) {
  const { user, token, authReady } = useAuth();
  const location = useLocation();

  // Wait for AuthContext to finish bootstrapping
  if (!authReady) return null;

  // ✅ Authenticated if either user or token exists
  if (user || token) {
    return children;
  }

  // ❌ Not authenticated — redirect to login
  return <Navigate to="/login" replace state={{ from: location }} />;
}
